import { BpkFlex } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import constants, { DIRECTNESS } from '../constants';
import withStrings from '../withStrings';

import type { DirectFlightLabelProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

const {
  STRINGS: { DIRECT, INDIRECT },
} = constants;

// BpkFlex (not BpkBox) so the text stays a flex item: a block container would add a
// parent-font line-height strut and make the row taller than the label's own line-height.
// minHeight keeps the row reserved when `direct` is UNKNOWN and no text renders.
const DirectFlightLabel = ({ direct, strings }: DirectFlightLabelProps) => (
  <BpkFlex minHeight="1rem">
    <BpkText
      color={TEXT_COLORS.textSecondary}
      textStyle={TEXT_STYLES.caption}
      data-testid="direct-flight-label"
    >
      {direct !== DIRECTNESS.UNKNOWN &&
        strings[direct === DIRECTNESS.DIRECT ? DIRECT : INDIRECT]}
    </BpkText>
  </BpkFlex>
);

export default withStrings(DirectFlightLabel);
